export const IDP_APP = 'IROP';
export const DEFAULT_TIMEOUT = 10000;

export enum EndpointKeys {
  IROP_GLOBAL_URL = 'IROP_GLOBAL_URL'
}
